import { getCaseS3Credentials } from "./cases3credentials";
import AWS from "aws-sdk";
import useSWR from "swr";
import awsConfig from '../cfg/aws-config.json';

async function getCaseS3ObjectUrl(bucketName, objectKey) {
  const region = awsConfig.default_region;
  console.log(`region=${region}`);
  const caseCredentialsResponse = await getCaseS3Credentials();
          if (!caseCredentialsResponse) {
            throw new Error('Could not get credentials to access file');
          }
            const credentials = caseCredentialsResponse.Credentials;
            const s3 = new AWS.S3({
                apiVersion: 'latest',
                region: region,
                credentials: {
                    accessKeyId: credentials.AccessKeyId,
                    secretAccessKey: credentials.SecretAccessKey,
                    sessionToken: credentials.SessionToken
                }
            });
            const params = {
                Bucket: bucketName,
                Key: objectKey,
                Expires: 60 * 5 // URL valid for 5 minutes
            };
            const url = s3.getSignedUrl('getObject', params);
            return url;
}

async function downloadCaseS3Object(bucketName, objectKey) {
    const url = await getCaseS3ObjectUrl(bucketName, objectKey);
    const response = await fetch(url);
    if (!response.ok) {
        throw new Error(`Failed to download S3 object: ${response.statusText}`);
    }
    const blob = await response.blob();
    return blob;
}

async function downloadCaseS3TextObject(bucketName, objectKey) {
    const url = await getCaseS3ObjectUrl(bucketName, objectKey);
    const response = await fetch(url);
    if (!response.ok) {
        throw new Error(`Failed to download S3 object: ${response.statusText}`);
    }
    const text = await response.text();
    return text;
}

export function useGetCaseS3TextObject(bucketName,objectKey,shouldFetch = true) {
  const result = useSWR(
    shouldFetch ? ['CASE_S3_TEXT', bucketName, objectKey] : null,
    ([Key,bucketName, objectKey]) => downloadCaseS3TextObject(bucketName, objectKey)
  );
  return result;
}

export function useGetCaseS3ObjectUrl(bucketName,objectKey,shouldFetch = true) {
  const result = useSWR(
    shouldFetch ? ['CASE_S3_URL', bucketName, objectKey] : null,
    ([Key,bucketName, objectKey]) => getCaseS3ObjectUrl(bucketName, objectKey),
    { refreshInterval: 60 * 4 * 1000, // refresh every 4 minutes to keep URL valid
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
      dedupingInterval: 60 * 4 * 1000, // Don't refetch same key within 4 minutes
    }
  );
  return result;
}